import type { Table } from 'mdast';

import type { State } from '../state';

export function table(state: State, node: Table): void {
	const nodeType = state.schema.nodes.table;
	if (!nodeType) {
		// Gracefully degrade: schema has no table node — render children directly
		// (tableRow/tableCell handlers will also degrade gracefully)
		state.parseTokens(node.children);
		return;
	}
	state.openNode(nodeType);
	state.parseTokens(node.children);
	state.closeNode();
}
